// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fG-z","hovered":"gG-z","hoverImage":"hG-z","mainImage":"iG-z","imageNoBackground":"jG-z","fullSizeImage":"kG-z"};